import { DtoBase } from '../../../types/Dtos/DtoBase'
import { CompareOptions } from './HistoryItem.model'

export class CompareHistoryItemsDto extends DtoBase {
  constructor(options: CompareOptions) {
    super(options)
  }
}
